export default {
  index: state => page => state.schemes[page]['list']['lookups'],

  schema: state => params => (state.schemes[params.page] ? state.schemes[params.page][params.mode] : null),

  title: state => page => state.schemes[page].title,

  showBreadcrumbs: state => page => state.schemes[page].breadcrumbs,

  mode: state => id => state.schemes[id].default,

  loaded: state => id => (state.schemes[id] ? true : false),

  mainPage: state => state.main,

  actions: state => params => state.schemes[params.page].list.recordActions[params.key],

  currentStep: state => page => (state.entries[page] ? state.entries[page]['default_step'] : undefined),

  entryModel: state => page => state.entries[page],

  actions_scheme: state => params => {
    let { tab, page, mode, step } = params;

    if (tab > 0 && state.schemes[page][mode].tabs) return state.schemes[page][mode].tabs.content[tab].actions;
    if (step > 0 && state.schemes[page][mode].steps) return state.schemes[page][mode].steps.content[step].actions;

    if (state.schemes[page]) return state.schemes[page][mode].actions;
  },

  model: state => params => {
    if (state.models[params.page]) {
      return state.models[params.page][params.mode];
    } else {
      return params.mode === 'list' ? [] : {};
    }
  }
};
